let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f5eEN")).then(() => parcelRequire('8iNv0'));